import { axiosInstance, VueInstance } from '~/main';
import { RevisionApplication } from '~/js/FormObjects';
import moment from 'moment';

export function errorNotification(prefix, error) {
  if (error === undefined) {
    VueInstance.$notify(`${prefix}`, 'error');
    return;
  }
  let message = '';
  if (error.response) {
    if (error.response.data) {
      message = error.response.data;
    }
    if (error.response.data.message) {
      // eslint-disable-next-line prefer-destructuring
      message = error.response.data.message;
    }
    if (Object.prototype.hasOwnProperty.call(error.response.data, 'exceptionMessage')) {
      message = error.response.data.exceptionMessage;
    }
  } else if (error.request) {
    message = error.request;
  } else {
    message = { error };
  }
  if (error.request == undefined) {
    VueInstance.$notify(`${prefix}`, 'error');
  } else {
    VueInstance.$notify(`${prefix}${message}`, 'error');
  }
}

// eslint-disable-next-line no-underscore-dangle
function __getApplication(url) {
  return new Promise((resolve, reject) => {
    axiosInstance.get(url)
      .then((response) => {
        const { data } = response;
        data.startDate = data.startDate ? new Date(data.startDate) : new Date();
        data.endDate = data.endDate ? new Date(data.endDate) : new Date();
        data.signDate = data.signDate ? new Date(data.signDate) : new Date();
        data.confirmEmail = data.contactEmail;

        data.existingFileDetails = {};
        data.fileDetails.forEach((x) => {
          data.existingFileDetails[x.documentName] = x;
        });
        resolve(data);
      })
      .catch((error) => {
        errorNotification('Error getting permit record: ', error);
        reject(error);
      });
  });
}

function __getOpenBurnApplication(url) {
  return new Promise((resolve, reject) => {
    axiosInstance.get(url)
      .then((response) => {
        const { data } = response;
        data.existingFileDetails = {};
        data.fileDetails.forEach((x) => {
          data.existingFileDetails[x.documentName] = x;
        });
        resolve(data);
      })
      .catch((error) => {
        errorNotification('Error getting permit record: ', error);
        reject(error);
      });
  });
}

export function getApplication(applicationNumber) {
  return __getApplication(`api/permit/${applicationNumber}`);
}

export function getDDDIApplication(applicationNumber) {
  const url = `api/permit/getDDDIPermit?applicationNumber=${applicationNumber}`;
  return new Promise((resolve, reject) => {
    axiosInstance.get(url)
      .then((response) => {
        const { data } = response;
        resolve(data);
      })
      .catch((error) => {
        errorNotification('Error getting permit record: ', error);
        reject(error);
      });
  });
}

export function getOpenBurnApplication(applicationNumber) {
  return __getOpenBurnApplication(`api/openburn/${applicationNumber}`);
}

export function submitOpenBurnNoFeeApplication(applicationNumber) {
  const url = `api/openburn/submitnofee?applicationNumber=${applicationNumber}`;
  return new Promise((resolve, reject) => {
    axiosInstance.post(url)
      .then((response) => {
        const { data } = response;
        resolve(data);
      })
      .catch((error) => {
        errorNotification('Error getting permit record: ', error);
        reject(error);
      });
  });
}

export function submitOpenBurnRecApplication(applicationNumber) {
  const url = `api/openburn/submitrec?applicationNumber=${applicationNumber}`;
  return new Promise((resolve, reject) => {
    axiosInstance.post(url)
      .then((response) => {
        const { data } = response;
        resolve(data);
      })
      .catch((error) => {
        errorNotification('Error getting permit record: ', error);
        reject(error);
      });
  });
}

export function saveOpenBurnRecApplication(applicationNumber) {
  const url = `api/openburn/saverec?applicationNumber=${applicationNumber}`;
  return new Promise((resolve, reject) => {
    axiosInstance.post(url)
      .then((response) => {
        const { data } = response;
        resolve(data);
      })
      .catch((error) => {
        errorNotification('Error getting permit record: ', error);
        reject(error);
      });
  });
}

export function submitOpenBurnApplication(applicationNumber) {
  const url = `api/openburn/submit?applicationNumber=${applicationNumber}`;
  return new Promise((resolve, reject) => {
    axiosInstance.post(url)
      .then((response) => {
        const { data } = response;
        resolve(data);
      })
      .catch((error) => {
        errorNotification('Error getting permit record: ', error);
        reject(error);
      });
  });
}

export function openBurnChase(applicationNumber) {
  const url = `api/openburn/chase?applicationNumber=${applicationNumber}`;
  return new Promise((resolve, reject) => {
    axiosInstance.post(url)
      .then((response) => {
        const { data } = response;
        resolve(data);
      })
      .catch((error) => {
        errorNotification('Error getting permit record: ', error);
        reject(error);
      });
  });
}

export function openBurnPaymentus(applicationNumber) {
  const url = `api/openburn/paymentus?applicationNumber=${applicationNumber}`;
  return new Promise((resolve, reject) => {
    axiosInstance.post(url)
      .then((response) => {
        const { data } = response;
        window.location = data.url;
      })
      .catch((error) => {
        errorNotification('Error getting permit record: ', error);
        reject(error);
      });
  });
}

export function openBurnLN(applicationNumber) {
  const url = `api/openburn/ln?applicationNumber=${applicationNumber}`;
  return new Promise((resolve, reject) => {
    axiosInstance.post(url)
      .then((response) => {
        const { data } = response;
        resolve(data);
      })
      .catch((error) => {
        errorNotification('Error getting permit record: ', error);
        reject(error);
      });
  });
}

export function getLNUrl() {
  const url = 'api/openburn/lnUrl';
  return new Promise((resolve, reject) => {
    axiosInstance.get(url)
      .then((response) => {
        const { data } = response;
        resolve(data);
      })
      .catch((error) => {
        errorNotification('', error);
        reject(error);
      });
  });
}

export function getOpenBurnCart(applicationNumber) {
  const url = `api/openburn/getcart?applicationNumber=${applicationNumber}`;
  return new Promise((resolve, reject) => {
    axiosInstance.get(url)
      .then((response) => {
        const { data } = response;
        resolve(data);
      })
      .catch((error) => {
        errorNotification('Error getting cart: ', error);
        reject(error);
      });
  });
}

export function getTransactionCart(transactionId) {
  const url = `api/openburn/gettransactioncart?transactionId=${transactionId}`;
  return new Promise((resolve, reject) => {
    axiosInstance.get(url)
      .then((response) => {
        const { data } = response;
        resolve(data);
      })
      .catch((error) => {
        errorNotification('Error getting cart: ', error);
        reject(error);
      });
  });
}

export function confirmChaseOpenBurnTransaction(transactionId, confirmationNumber) {
  const url = `api/openburn/confirmChaseTransaction?transactionId=${transactionId}&confirmationNumber=${confirmationNumber}`;
  return new Promise((resolve, reject) => {
    axiosInstance.post(url)
      .then((response) => {
        const { data } = response;
        resolve(data);
      })
      .catch((error) => {
        errorNotification('Error getting permit record: ', error);
        reject(error);
      });
  });
}

export function getOpenBurnFeeStatus(applicationNumber) {
  const url = `api/openburn/feestatus?applicationNumber=${applicationNumber}`;
  return new Promise((resolve, reject) => {
    axiosInstance.get(url)
      .then((response) => {
        const { data } = response;
        resolve(data);
      })
      .catch((error) => {
        errorNotification('Error getting fee status ', error);
        reject(error);
      });
  });
}

export function checkPdf(applicationNumber) {
  const url = `api/permit/permit?permitNumber=${applicationNumber}`;
  return new Promise((resolve, reject) => {
    axiosInstance.get(url)
      .then((response) => {
        const { data } = response;
        resolve(data);
      })
      .catch((error) => {
        errorNotification('Error printing PDF', error);
        reject(error);
      });
  });
}

export function getPermit(applicationNumber) {
  const url = `api/permit/getPermit?applicationNumber=${applicationNumber}`;
  return new Promise((resolve, reject) => {
    axiosInstance.get(url)
      .then((response) => {
        const { data } = response;
        resolve(data);
      })
      .catch((error) => {
        errorNotification('Error getting permit record: ', error);
        reject(error);
      });
  });
}

export function validatePermitNumber(permitNumber) {
  const url = `api/permit/validatePermitNumber?permitNumber=${permitNumber}`;
  return new Promise((resolve, reject) => {
    axiosInstance.get(url)
      .then((response) => {
        const { data } = response.data;
        resolve(data);
      })
      .catch((error) => {
        errorNotification('Permit number must contain only numbers and letters', undefined);
        reject(error);
      });
  });
}

export function getEquipment(siteNumber) {
  const url = `api/equipment/getequipment?siteNumber=${siteNumber}`;
  return new Promise((resolve, reject) => {
    axiosInstance.get(url)
      .then((response) => {
        const { data } = response;
        resolve(data);
      })
      .catch((error) => {
        errorNotification('No equipment found for site', siteNumber);
        reject(error);
      });
  });
}

export function getSite(siteNumber) {
  const url = `api/equipment/getSite?siteNumber=${siteNumber}`;
  return new Promise((resolve, reject) => {
    axiosInstance.get(url)
      .then((response) => {
        const { data } = response;
        resolve(data);
      })
      .catch((error) => {
        errorNotification('Error getting site record: ', error);
        reject(error);
      });
  });
}

export function getSiteInvoices(siteNumber) {
  const url = `api/site/getinvoices?siteNumber=${siteNumber}`;
  return new Promise((resolve, reject) => {
    axiosInstance.get(url)
      .then((response) => {
        const { data } = response;
        resolve(data);
      })
      .catch((error) => {
        errorNotification('Error getting site invoice records: ', error);
        reject(error);
      });
  });
}

export function getSiteCOO(siteNumber) {
  const url = `api/site/getsitecoo?siteNumber=${siteNumber}`;
  return new Promise((resolve, reject) => {
    axiosInstance.get(url)
      .then((response) => {
        const { data } = response;
        resolve(data);
      })
      .catch((error) => {
        errorNotification('Error getting site COO records: ', error);
        reject(error);
      });
  });
}

export function getSiteCOOPdf(COOId) {
  const url = `api/site/getsitecoopdf?COOId=${COOId}`;
  return new Promise((resolve, reject) => {
    axiosInstance.get(url)
      .then((response) => {
        const { data } = response;
        resolve(data);
      })
      .catch((error) => {
        errorNotification('Error getting site COO records: ', error);
        reject(error);
      });
  });
}

export function getPayAbility(siteNumber) {
  const url = `api/site/abletopay?siteNumber=${siteNumber}`;
  return new Promise((resolve, reject) => {
    axiosInstance.get(url)
      .then((response) => {
        const { data } = response;
        resolve(data);
      })
      .catch((error) => {
        errorNotification('Payment cannot be completed because the payment due date has passed. Please contact the department at certificateofoperations@cookcountyil.gov for assistance regarding your COO.', error);
        reject(error);
      });
  });
}

export function getSiteMasterBalance(siteNumber) {
  const url = `api/site/getsitebalance?siteNumber=${siteNumber}`;
  return new Promise((resolve, reject) => {
    axiosInstance.get(url)
      .then((response) => {
        const { data } = response;
        resolve(data);
      })
      .catch((error) => {
        errorNotification('Error getting site master balance: ', error);
        reject(error);
      });
  });
}

export function getLandingCallback() {
  const url = 'api/DesAir/landingcallback';
  return new Promise((resolve, reject) => {
    axiosInstance.get(url)
      .then((response) => {
        const { data } = response;
        resolve(data);
      })
      .catch((error) => {
        errorNotification('Error getting site invoice records: ', error);
        reject(error);
      });
  });
}

export function getInvoice(invoiceNumber) {
  const url = `api/site/getInvoice?invoiceNumber=${invoiceNumber}`;
  return new Promis((resolve, reject) => {
    axiosInstance.get(url)
      .then((response) => {
        const { data } = response;
        reslove(data);
      })
      .catch((error) => {
        errorNotification('Error getting invoice: ', error);
      });
  });
}


export function getSiteChanges(siteNumber) {
  const url = `api/equipment/getsitechanges?siteNumber=${siteNumber}`;
  return new Promise((resolve, reject) => {
    axiosInstance.get(url)
      .then((response) => {
        const { data } = response;
        resolve(data);
      })
      .catch((error) => {
        errorNotification('Error getting site change records: ', error);
        reject(error);
      });
  });
}

export function submitChangeFee(siteNumber, toAdd, toDecom) {
  const url = 'api/equipment/submitChangeFees';
  const siteEquipmentChanges = { SiteNumber: siteNumber, EquipmentAdded: toAdd, EquipmentDecommissioned: toDecom };
  return new Promise((resolve, reject) => {
    axiosInstance.post(url, siteEquipmentChanges)
      .then((response) => {
        const { data } = response;
        resolve(data);
      })
      .catch((error) => {
        errorNotification('Error getting site change records: ', error);
        reject(error);
      });
  });
}

export function getChangeFees(equipmentRegistrationId) {
  const url = `api/equipment/getChangeFees?equipmentRegistrationId=${equipmentRegistrationId}`;
  return new Promise((resolve, reject) => {
    axiosInstance.post(url)
      .then((response) => {
        const { data } = response;
        resolve(data);
      })
      .catch((error) => {
        errorNotification('Error getting site change records: ', error);
        reject(error);
      });
  });
}

export function getPayAchUrl(siteNumber, equipmentRegistrationId, requestId, email) {
  const url = `api/equipment/payach?siteNumber=${siteNumber}&erid=${equipmentRegistrationId}&requestId=${requestId}&email=${email}`;
  return new Promise((resolve, reject) => {
    axiosInstance.post(url)
      .then((response) => {
        resolve(response.data.url);
      })
      .catch((error) => {
        errorNotification('Error getting pay ach url: ', error);
        reject(error);
      });
  });
}

export function completeRegistration(siteNumber, equipmentRegistrationId, requestId, email) {
  const url = `api/equipment/completeregistration?siteNumber=${siteNumber}&erid=${equipmentRegistrationId}&requestId=${requestId}&email=${email}`;
  return new Promise((resolve, reject) => {
    axiosInstance.post(url)
      .then((response) => {
        const { data } = response;
        resolve(data);
      })
      .catch((error) => {
        errorNotification('Error getting pay ach url: ', error);
        reject(error);
      });
  });
}
// Changing to Paymentus integration.
export function getInvoicePayAchUrl(siteNumber, email, fileRequestId) {
  const url = `api/site/payach?siteNumber=${siteNumber}&paymentGateway=Paymentus&email=${email}&fileRequestId=${fileRequestId}`;
  return new Promise((resolve, reject) => {
    axiosInstance.post(url)
      .then((response) => {
        resolve(response.data.url);
      })
      .catch((error) => {
        errorNotification('Error getting pay ach url: ', error);
        reject(error);
      });
  });
}

export function saveIepaPermit(form, siteNumber) {
  const url = 'api/site/saveiepapermit';
  const body = {
    siteNumber,
    iepaPermit: form.iepaPermit,
    carbonDioxide: form.carbonDioxide,
    methane: form.methane,
    n2o: form.n2o,
    particulate25: form.particulate25,
    particulate10: form.particulate10,
    nox: form.nox,
    sulfurDioxide: form.sulfurDioxide,
    carbonMonoxide: form.carbonMonoxide,
    ozone: form.ozone,
    vomTotal: form.vomTotal,
    ethyleneOxide: form.ethyleneOxide,
    lead: form.lead,
    naicsCode: form.naicsCode,
    naicsDescription: form.naicsDescription,
    year: form.year,
    totalEmployees: form.totalEmployees,
    facilitySqFootage: form.facilitySqFootage,
    naicsOther: form.naicsOther,
  };
  return new Promise((resolve, reject) => {
    axiosInstance.post(url, body)
      .then((response) => {
        const { data } = response;
        resolve(data);
      })
      .catch((error) => {
        errorNotification('Error posting IEPA Permit data: ', error);
        reject(error);
      });
  });
}

export function getInvoiceLexisLexusUrl(siteNumber) {
  const url = `api/site/payBalance?siteNumber=${siteNumber}&paymentGateway=LexusNexus`;
  return new Promise((resolve, reject) => {
    axiosInstance.post(url)
      .then((response) => {
        const { data } = response;
        resolve(data);
      })
      .catch((error) => {
        errorNotification('Error getting pay ach url: ', error);
        reject(error);
      });
  });
}

export function confirmTransaction(gatewayKey, confirmationNumber, requestId) {
  const url = `api/site/confirmtransaction?gatewayKey=${gatewayKey}&confirmationNumber=${confirmationNumber}&requestId=${requestId}`;
  return new Promise((resolve, reject) => {
    axiosInstance.post(url)
      .then((response) => {
        const { data } = response;
        resolve(data);
      })
      .catch((error) => {
        errorNotification('Error getting pay ach url: ', error);
        reject(error);
      });
  });
}

export function getRevisionApplication(applicationNumber) {
  return new Promise((resolve, reject) => {
    __getApplication(`api/revision/getPermit/${applicationNumber}`)
      .then((permitApplication) => {
        resolve(new RevisionApplication(permitApplication));
      })
      .catch((error) => {
        // we're notifying in __getApplication() anyway
        // errorNotification('Error getting revision application: ', error)
        reject(error);
      });
  });
}

export function decommissionEquipemnt(siteNumber, equipmentList) {
  return new Promise((resolve, reject) => {
    axiosInstance.post(`api/equipment/decomEquipment?siteNumber=${siteNumber}`, equipmentList)
      .then((data) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function requestSite(siteInfo) {
  return new Promise((resolve, reject) => {
    axiosInstance.post('api/site/siterequest', siteInfo)
      .then((data) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function uploadFile(file, siteNumber, requestId, fileType) {
  const formData = new FormData();
  formData.append('file', file);
  return new Promise((resolve, reject) => {
    axiosInstance.post(
      `api/equipment/uploadfile?siteNumber=${siteNumber}&requestId=${requestId}&fileType=${fileType}`, formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    )
      .then((data) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function removeFile(fileId) {
  return new Promise((resolve, reject) => {
    axiosInstance.post(`api/equipment/removefile?fileId=${fileId}`)
      .then((data) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function getFileStatuses(requestId) {
  return new Promise((resolve, reject) => {
    axiosInstance.get(`api/equipment/getuploadstatuses?requestId=${requestId}`)
      .then((data) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function getFileRequestId() {
  return new Promise((resolve, reject) => {
    axiosInstance.get('api/equipment/generateRequestId')
      .then((data) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function validateFiles(requestId) {
  return new Promise((resolve, reject) => {
    axiosInstance.get(`api/equipment/validatefiles?requestId=${requestId}`)
      .then((data) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function submitSiteChanges(siteNumber) {
  return new Promise((resolve, reject) => {
    axiosInstance.post(`api/equipment/submitsitechanges?siteNumber=${siteNumber}`)
      .then((data) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function submitEquipmentChangeRequest(equipmentRegistrationId) {
  return new Promise((resolve, reject) => {
    axiosInstance.post(`api/equipment/submitchangerequest?equipmentRegistrationId=${equipmentRegistrationId}`)
      .then((data) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function getTypeCodes() {
  return new Promise((resolve, reject) => {
    axiosInstance.get('api/equipment/gettypecodes')
      .then((data) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function getUseCodes() {
  return new Promise((resolve, reject) => {
    axiosInstance.get('api/equipment/getusecodes')
      .then((data) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function getUsageMetricCodes() {
  return new Promise((resolve, reject) => {
    axiosInstance.get('api/equipment/getusagemetriccodes')
      .then((data) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function confirmChasePayment(shoppingCartId, chaseConfirmationCode, sessionId) {
  return new Promise((resolve, reject) => {
    axiosInstance.post('api/checkout/chaseConfirm', {
      shoppingCartId,
      chaseConfirmationCode,
      sessionId,
    })
      .then((response) => {
        const { data } = response;
        resolve(data);
      })
      .catch((error) => {
        errorNotification('Error confirming payment: ', error);
        reject(error);
      });
  });
}

export function getCart(shoppingCartId) {
  return new Promise((resolve, reject) => {
    axiosInstance.get(`api/checkout/cart/${shoppingCartId}`)
      .then((response) => {
        const { data } = response;
        resolve(data);
      })
      .catch((error) => {
        errorNotification('Error getting cart: ', error);
        reject(error);
      });
  });
}

export function getContractorRegistration(idphNumber) {
  return new Promise(((resolve, reject) => {
    axiosInstance.get(`api/contractor/${idphNumber}`)
      .then((response) => {
        const { data } = response;
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  }));
}
export function getPrice(feeAttributes) {
  return new Promise(((resolve) => {
    axiosInstance.get('api/fee/calculate', {
      params: feeAttributes,
    })
      .then((response) => {
        resolve(response.data);
      });
  }));
}

export function getPermitCart(urlParameters, saveCart = false) {
  return new Promise(((resolve, reject) => {
    const params = Object.assign(urlParameters, { saveCart });
    axiosInstance.get('api/checkout/cart', {
      params,
    })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        errorNotification('Error getting cart: ', error);
        reject(error);
      });
  }));
}

export function getLexisNexisPaymentData(siteNumber, equipmentRegistrationId, requestId, email) {
  const url = `api/equipment/lnpaydata?siteNumber=${siteNumber}&erid=${equipmentRegistrationId}&requestId=${requestId}&email=${email}`;
  return new Promise((resolve, reject) => {
    axiosInstance.get(url)
      .then((response) => {
        const { data } = response;
        resolve(data);
      })
      .catch((error) => {
        errorNotification('Error getting Lexis Nexis payment data: ', error);
        reject(error);
      });
  });
}

export function getInvoiceLexisNexisPaymentData(siteNumber, email, fileRequestId) {
  const url = `api/site/lnpaydata?siteNumber=${siteNumber}&email=${email}&fileRequestId=${fileRequestId}`;
  return new Promise((resolve, reject) => {
    axiosInstance.post(url)
      .then((response) => {
        const { data } = response;
        resolve(data);
      })
      .catch((error) => {
        errorNotification('Error getting Lexis Nexis payment data: ', error);
        reject(error);
      });
  });
}

export function getOMFacilities() {
  return new Promise(((resolve, reject) => {
    axiosInstance.get('api/facility/OMFacilities')
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        errorNotification('Error getting facilities: ', error);
        reject(error);
      });
  }));
}

export function getOMFacility(facilityId) {
  return new Promise(((resolve, reject) => {
    axiosInstance.get('api/facility/OMFacility', {
      params: {
        facilityId,
      },
    })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        errorNotification('Error getting O&M Facility: ', error);
        reject(error);
      });
  }));
}

export function getPrices(projectType) {
  return new Promise(((resolve, reject) => {
    axiosInstance.get('api/fee/applicationFees', {
      params: {
        permitType: projectType,
      },
    })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        errorNotification('Error getting prices: ', error);
        reject(error);
      });
  }));
}

export function saveRevision(formData) {
  return new Promise(((resolve, reject) => {
    axiosInstance.post('/api/revision/submit', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        errorNotification('Error saving revision: ', error);
        reject(error);
      });
  }));
}

export function getContractors(type = 'demolition') {
  return new Promise(((resolve, reject) => {
    axiosInstance.get('api/contractor/current', {
      params: {
        contractorType: type,
      },
    })
      .then((response) => {
        VueInstance.$store.commit(`${type}Contractors`, response.data);
        resolve(response.data);
      })
      .catch((error) => {
        errorNotification('Error getting contractors: ', error);
        reject(error);
      });
  }));
}

export function getFacilities() {
  return new Promise(((resolve, reject) => {
    axiosInstance.get('api/facility/demolition')
      .then((response) => {
        VueInstance.$store.commit('Facilities', response.data);
        resolve(response.data);
      })
      .catch((error) => {
        errorNotification('Error getting facilities: ', error);
        reject(error);
      });
  }));
}

export function getMaterials() {
  return new Promise(((resolve, reject) => {
    axiosInstance.get('api/permit/data/materials')
      .then((response) => {
        VueInstance.$store.commit('Materials', response.data);
        resolve(response.data);
      })
      .catch((error) => {
        errorNotification('Error getting materials: ', error);
        reject(error);
      });
  }));
}

export function finalizeCart(shoppingCartId) {
  return new Promise((resolve, reject) => {
    axiosInstance.post('api/checkout/finalize', {
      shoppingCartId,
    })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        errorNotification('Error finalizing cart: ', error);
        reject(error);
      });
  });
}

export function capitalize(value) {
  if (!value) return '';
  const ret = value.toString();
  return ret.charAt(0).toUpperCase() + ret.slice(1);
}

export function removeAMPM(time) {
  if (!time) {
    return time;
  }
  let ret = time.toString();
  ret = ret.replace('AM', '');
  ret = ret.replace('PM', '');
  return ret;
}

export function getErrors(validationObj, errors = []) {
  if (!validationObj || !validationObj.$error) {
    return errors;
  }
  let tempArray = errors;
  if (validationObj.$error) {
    const keys = Object.keys(validationObj);
    for (let i = 0; i < keys.length; i += 1) {
      const key = keys[i];
      if (validationObj[key] && validationObj[key].$error) {
        tempArray.push(key);
        tempArray = tempArray.concat(getErrors(validationObj[key], errors));
      }
    }
  }
  // unique-ify's the thing
  return tempArray.filter((value, index, self) => self.indexOf(value) === index);
}

export function addWeekdays(date, days) {
  let m = moment(date);
  let dayCount = Math.abs(days);
  const inc = days / Math.abs(days);
  while (dayCount !== 0) {
    m = m.add(inc, 'days');
    if (m.isoWeekday() !== 6 && m.isoWeekday() !== 7) {
      dayCount -= 1;
    }
  }
  return m;
}

export function isNullOrEmpty(value) {
  return value === undefined || value === null || value === '';
}
